import { FC } from 'react';
import { navigate } from 'gatsby';
import classNames from 'classnames';
import { useStripeSetupIntent } from '../../../hooks';
import { DefaultLayout, StripeFormWrapper, AddPaymentMethodForm } from '../../../components';

const AccountNewPaymentMethodPage: FC = () => {
  const { clientSecret } = useStripeSetupIntent();
  const redirectPath = '/account/payment-methods';

  return (
    <DefaultLayout title="Account - New Payment Method" className={classNames('account-new-payment-method')}>
      <StripeFormWrapper clientSecret={clientSecret}>
        <AddPaymentMethodForm redirectPath={redirectPath} onCancel={() => navigate(`/account/payment-methods`)} />
      </StripeFormWrapper>
    </DefaultLayout>
  );
};

export default AccountNewPaymentMethodPage;
